import * as css from './style.css';
import Btn from '../../../component/button/btn/Btn';
import {STATIC_IMAGE, TICK_DOMAIN} from '../../../config/config';
import {useTranslation} from 'react-i18next';
import Card from './card/card';
import {OrderData} from '../suspendedConfirmation';

const WontComeMessage = ({orderData}: {orderData: OrderData}) => {
    const {t} = useTranslation('suspendedConfirmation');

    return (
        <Card subTitle={t('cantChange', {nameFirst: orderData.nameFirst})} mainTitle={orderData.eventTitle} {...orderData}>
            <css.confirmationBoxFlexCenter>
                <css.rightBox>
                    <css.boldText>
                        {t('decisionExplanation')}
                    </css.boldText>
                </css.rightBox>
                <css.image 
                    src={`${STATIC_IMAGE}/app/ArrivalConfirmation/irreversible.png`}
                    alt="" 
                />
            </css.confirmationBoxFlexCenter>
                
            <css.buttonRow>
                <Btn href={TICK_DOMAIN} onClick={undefined}>
                    {t('finish')}
                </Btn>
            </css.buttonRow>        
        </Card>
    );
};

export default WontComeMessage;